import { logout, refresh } from '../../../API/User';
import jwt from 'jsonwebtoken';
import { save, remove } from '../../../Utils/localStorage';
import { userLogout, setUserData, setAuthState } from './index';
import { query, authQuery } from '../../../API';
import { defaultUserState } from '../../Reducers/UserReducer';

export const refreshRx = async (dispatch, token) => {
  const result = await authQuery(token, refresh);
  if (result.data.code === 401) {
    dispatch(setAuthState(false));
    dispatch(userLogout(defaultUserState));
    remove('User');
    return null;
  }
  if (result.data) {
    const { tokenAccess, tokenRefresh } = result.data;
    dispatch(setUserData({ tokenAccess, tokenRefresh }));
  }
  return result.data;
};

export const logoutRx = async (dispatch, token, refreshToken) => {
  let result = await authQuery(token, logout);
  if (result.data.code === 401) {
    const { tokenAccess = null } = await refreshRx(dispatch, refreshToken);
    result = await authQuery(tokenAccess, logout);
  }
  dispatch(setAuthState(false));
  dispatch(userLogout(defaultUserState));
  remove('User');
  return result?.data;
};

export const authRx = async (
  dispatch,
  fn,
  action,
  accessToken,
  refreshToken,
  payload,
  ...args
) => {
  let type = {};
  let controls;
  if (payload.content) type['content-type'] = payload.content;
  if (payload.controls) controls = payload.controls;
  let result = await authQuery(accessToken, action, payload, type, controls);
  if (result.data.code === 401) {
    const { tokenAccess = null, tokenRefresh = null } = await refreshRx(
      dispatch,
      refreshToken,
    );
    if (tokenAccess && tokenRefresh) {
      result = await authQuery(tokenAccess, action, payload, type, controls);
    }
  }
  fn(result, ...args);
  return result;
};

export const authMediaRx = async (
  dispatch,
  fn,
  action,
  refreshToken,
  payload,
  ...args
) => {
  let type = {};
  let controls;
  if (payload.content) type['content-type'] = payload.content;
  if (payload.controls) controls = payload.controls;
  let result;
  const { tokenAccess = null } = await refreshRx(dispatch, refreshToken);
  if (tokenAccess) {
    result = await authQuery(tokenAccess, action, payload, type, controls);
    fn(result, ...args);
  }
  return result;
};

export const unauthRx = async (dispatch, fn, action, payload, ...args) => {
  let result = await query(action, payload);
  fn(dispatch, result, ...args);
  return result;
};

export const loginRx = (dispatch, result, e) => {
  if (result.data.data) {
    const { role } = jwt.verify(result.data.tokenAccess, 'mysecretkey');
    const user = {
      ...result.data.user,
      role,
      tokenAccess: result.data.tokenAccess,
      tokenRefresh: result.data.tokenRefresh,
    };
    save('User', JSON.stringify(user));
    dispatch(setUserData(user));
    dispatch(setAuthState(true));
    setTimeout(() => {
      e?.target.closest('form')?.parentElement?.click();
    }, 1000);
  }
};
